const TRAINING_REPORTS_ROUTES = {
  path: 'training-reports',
  component: () =>
    import('@/pages/TrainingReports/TrainingReportsPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'training-reports.index',
      component: () =>
        import('@/pages/TrainingReports/TrainingReportsPage.vue'),
    },
  ],
};

export default TRAINING_REPORTS_ROUTES;
